// extracted by mini-css-extract-plugin
export default {"card":"NoteList_card__zejV9"};